import { TreatmentSetting } from 'app/core/models';
import { TreatmentType } from 'app/core/enums';
import { ImplantAbutmentBrands } from './abutment-brands';

export const TreatmentSettings: TreatmentSetting[] = [
    {
        id: TreatmentType.NightGuard,
        details: {
            hasArch: true,
            multyArch: false,
            hasPrintAndShip: true,
            checklist: null,
            subTypes: {
                title: 'general.guardType',
                description: '',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.additionalNotes',
                description: '',
                inputLabel: 'messages.treatmentPlanInputLabelForOG',
                required: false,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: true,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 4,
            rushServiceEnable: true,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
    },
    {
        id: TreatmentType.SmileDesign,
        details: {
            hasArch: false,
            multyArch: false,
            checklist: null,
            subTypes: {
                title: 'general.designStyle',
                description: 'messages.selectTreatmentSubTypeSmileDesignNote',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.additionalNotes',
                description: 'general.anythingYouWantUsToLookOut',
                inputLabel: 'messages.treatmentPlanInputLabelForSmileDesign',
                required: true,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: true,
            infoQuestionsInitOrder: 4,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
    },
    {
        id: TreatmentType.SurgicalGuide,
        details: {
            hasArch: false,
            multyArch: false,
            checklist: null,
            subTypes: {
                title: 'general.turnaroundTime',
                description: '',
                columns: 1,
                isList: true,
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.treatmentPlan',
                description: '',
                inputLabel: 'messages.treatmentPlanRequiredInputLabel',
                required: true,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: true,
            infoQuestionsInitOrder: 4,
            hasImplants: true,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
    },
    {
        id: TreatmentType.ClearAligner,
        details: {
            hasArch: true,
            multyArch: true,
            checklist: null,
            subTypes: {
                title: '',
                description: '',
            },
            detailsTemplate: 'clearAlignerTemplate',
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.treatmentInstructions',
                description: '',
                inputLabel: 'messages.includingAnyPostOrthodontics',
                required: true,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 0,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
        assembledView: {
            enable: true,
            viewerLinkMode: true,
        },
    },
    {
        id: TreatmentType.SingleImplantWithCrown,
        details: {
            hasArch: false,
            multyArch: false,
            checklist: null,
            subTypes: null,
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.treatmentPlan',
                description: '',
                inputLabel: 'messages.treatmentPlanRequiredInputLabel',
                required: true,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: true,
            infoQuestionsInitOrder: 4,
            hasImplants: true,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
    },
    {
        id: TreatmentType.ImplantRestorations,
        details: {
            hasArch: false,
            multyArch: false,
            checklist: null,
            subTypes: {
                title: 'general.treatmentType',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.treatmentPlan',
                description: '',
                inputLabel: 'messages.treatmentPlanInputLabel',
                required: true,
            },
            textAnnotation: null,
            comment: null,
            hasTightness: false,
            hasTeethNotes: true,
            infoQuestionsInitOrder: 4,
            hasImplantAbutmentModelInformation: true,
            rushServiceEnable: false,
            abutmentBrands: ImplantAbutmentBrands,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
        assembledView: {
            enable: true,
        },
    },
    {
        id: TreatmentType.RemovableDentures,
        details: {
            hasArch: true,
            multyArch: true,
            checklist: null,
            subTypes: {
                title: '',
                description: '',
            },
            detailsTemplate: 'removableDenturesTemplate',
            showInitiallyAdditionalFields: false,
            additionalNotes: {
                title: 'general.treatmentPlan',
                description: '',
                inputLabel: 'general.detailOfVdoModification',
                required: false,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 0,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
        assembledView: {
            enable: true,
        },
    },
    {
        id: TreatmentType.AINightGuard,
        details: {
            hasArch: true,
            multyArch: false,
            checklist: null,
            subTypes: {
                title: 'general.biteScanType',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: null,
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 4,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
        assembledView: {
            enable: true,
        },
    },
    {
        id: TreatmentType.AIRetainer,
        details: {
            hasArch: true,
            multyArch: true,
            checklist: null,
            subTypes: {
                title: 'general.biteScanType',
            },
            showInitiallyAdditionalFields: false,
            additionalNotes: null,
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 0,
            useRecommendedResin: true,
            hideMaterialSelection: true,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: true },
        printSettings: {},
        hideShadeItems: true,
        revision: {
            redraftWithInfo: true,
            redraftWithArchType: true,
            redraftMultiArch: true,
            redraftWithTextAnnotation: true,
        },
    },
    {
        id: TreatmentType.HybridDentures,
        details: {
            hasArch: true,
            multyArch: true,
            checklist: null,
            subTypes: {
                title: 'general.turnaroundTime',
                description: '',
                columns: 1,
                isList: true,
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.additionalComments',
                description: '',
                inputLabel: 'messages.treatmentPlanInputLabel',
                required: true,
            },
            textAnnotation: null,
            comment: null,
            hasTightness: false,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 4,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
    },
    {
        id: TreatmentType.SmileCorrect,
        details: {
            hasArch: true,
            multyArch: true,
            checklist: null,
            subTypes: {
                title: '',
                description: '',
            },
            detailsTemplate: 'clearAlignerTemplate',
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.treatmentInstructions',
                description: '',
                inputLabel: 'messages.includingAnyPostOrthodontics',
                required: true,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 0,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
        assembledView: {
            enable: true,
            viewerLinkMode: true,
        },
    },
    {
        id: TreatmentType.CustomBleachingTray,
        details: {
            hasArch: true,
            multyArch: true,
            checklist: null,
            subTypes: null,
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.treatmentPlan',
                description: ' ',
                inputLabel: 'messages.treatmentPlanInputLabel',
                required: false,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 0,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
    },
    {
        id: TreatmentType.Veneers,
        details: {
            hasArch: false,
            multyArch: false,
            hasVeneerType: true,
            hasPrintAndShip: true,
            checklist: null,
            subTypes: {
                title: 'general.designStyle',
                description: 'messages.selectTreatmentSubTypeSmileDesignNote',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.patientSChiefComplaint',
                description: '',
                inputLabel: 'general.enterNotes',
                required: true,
            },
            comment: {
                title: 'general.additionalComments',
                description: '',
                inputLabel: 'messages.treatmentPlanInputLabel',
                required: false,
                maxLength: 200,
            },
            textAnnotation: null,
            hasTightness: false,
            hasTeethNotes: true,
            infoQuestionsInitOrder: 0,
            showAddNightGuardOptions: true,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: false,
        printServiceOnly: true,
        showBackupQuantityOption: false,
        defaultBackQuantity: 1,
        veneer: {
            showAddExtraNightGuard: false,
        },
    },
    {
        id: TreatmentType.Moment,
        details: {
            hasArch: false,
            multyArch: false,
            hasVeneerType: true,
            hasPrintAndShip: true,
            checklist: null,
            subTypes: {
                title: 'general.designStyle',
                description: 'messages.selectTreatmentSubTypeSmileDesignNote',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.patientSChiefComplaint',
                description: '',
                inputLabel: 'general.enterNotes',
                required: true,
            },
            comment: {
                title: 'general.additionalComments',
                description: '',
                inputLabel: 'messages.treatmentPlanInputLabel',
                required: false,
                maxLength: 200,
            },
            textAnnotation: null,
            hasTightness: false,
            hasTeethNotes: true,
            infoQuestionsInitOrder: 0,
            showAddNightGuardOptions: true,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: false,
        printServiceOnly: true,
        showBackupQuantityOption: false,
        veneer: {
            fixedShadeName: 'general.thisIsMomentTreatment',
            showAddExtraNightGuard: false,
        },
    },
    {
        id: TreatmentType.CrownAndBridge,
        details: {
            hasArch: false,
            multyArch: false,
            checklist: null,
            subTypes: {
                title: 'general.treatmentType',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.treatmentPlan',
                description: '',
                inputLabel: 'messages.treatmentPlanInputLabel',
                required: true,
            },
            textAnnotation: null,
            comment: null,
            hasTightness: false,
            hasTeethNotes: true,
            infoQuestionsInitOrder: 4,
            rushServiceEnable: true,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
        assembledView: {
            enable: true,
        },
    },
    {
        id: TreatmentType.AICrown,
        details: {
            hasArch: false,
            multyArch: false,
            checklist: {
                title: 'general.aIDesignChecklist',
                info: 'messages.aiCrownCheckListDescription',
                infoIcon: 'warning-triangle',
                infoIconSize: '24px',
                steps: [
                    {
                        value: 'messages.aiCrownCheckListStepOne',
                        children: [
                            'messages.aiCrownCheckListStepOnePointOne',
                            'messages.aiCrownCheckListStepOnePointTwo',
                        ],
                    },
                    {
                        value: 'messages.aiCrownCheckListStepTwo',
                        children: ['messages.aiCrownCheckListStepTwoPointOne'],
                    },
                    {
                        value: 'messages.aiCrownCheckListStepThree',
                        children: ['messages.aiCrownCheckListStepThreePointOne'],
                    },
                ],
            },
            subTypes: {
                title: 'general.treatmentType',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: null,
            textAnnotation: null,
            comment: null,
            hasTightness: false,
            hasTeethNotes: true,
            showInfoQuestionAfterTeethNotes: true,
            infoQuestionsInitOrder: 4,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
    },
    {
        id: TreatmentType.DentalModel,
        details: {
            hasArch: true,
            multyArch: true,
            checklist: null,
            subTypes: {
                title: '',
                description: '',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.additionalNotes',
                description: '',
                inputLabel: 'messages.additionalNotesPlaceholder',
                required: false,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 0,
            hideMaterialSelection: true,
            printService: {
                materialSelectionReadonly: true,
                hideBackQuantity: true,
            },
            defaultResin: {
                id: '2004',
            },
        },
        files: { selectScanner: false, enableOptionalScanFilesUpload: true },
        printSettings: {},
        hideShadeItems: true,
        assembledView: {
            enable: true,
        },
    },
    {
        id: TreatmentType.ManualRetainer,
        details: {
            hasArch: true,
            multyArch: true,
            checklist: null,
            subTypes: {
                title: '',
                description: '',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.additionalNotes',
                description: '',
                inputLabel: 'messages.additionalNotesPlaceholder',
                required: false,
            },
            textAnnotation: {
                title: 'general.textLabel',
                description: 'general.limitCharacters',
                inputLabel: 'general.examplePlaceholder',
                required: false,
                maxLength: 5,
            },
            comment: null,
            hasTightness: false,
            hasTeethNotes: false,
            infoQuestionsInitOrder: 0,
            hideMaterialSelection: true,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: true },
        printSettings: {},
        hideShadeItems: true,
    },
    {
        id: TreatmentType.AICrownWithCAD,
        details: {
            hasArch: false,
            multyArch: false,
            checklist: null,
            subTypes: {
                title: 'general.treatmentType',
            },
            showInitiallyAdditionalFields: true,
            additionalNotes: {
                title: 'general.treatmentPlan',
                description: '',
                inputLabel: 'messages.treatmentPlanInputLabel',
                required: false,
            },
            textAnnotation: null,
            comment: null,
            hasTightness: false,
            hasTeethNotes: true,
            infoQuestionsInitOrder: 4,
        },
        files: { selectScanner: true, enableOptionalScanFilesUpload: false },
        printSettings: {},
        hideShadeItems: true,
    },
];

export function findTreatmentSetting(treatmentType: TreatmentType) {
    return { ...TreatmentSettings.find(t => t.id === treatmentType) };
}
